import { useNavigate } from 'react-router-dom';
//services
import { summarizeBalanceProcess } from 'services/balance.services';
//reducers
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
//components
import { FormButton } from 'theme/elements/Buttons';
import { SuccessIconMessage } from 'theme/elements/Icons';
import { FormsStack } from 'theme/elements/Forms';
import { MessageCard } from 'theme/elements/Cards';
import { CenteredText } from 'theme/elements/Content';
import { HeaderPage1 } from 'theme/elements/Headers';
//sections
//mui
import { Button } from '@mui/material';
//constants
import { pagesEnum } from 'constants/ui.constants';
import { balanceTransStepsPrefix } from 'constants/balance.constants';
import { setStartLoadingActivities } from 'state/reducers/activity.reducers';

export default function Step4(props: { handleCancel: any; handleClose: () => void }) {
	const t = useAppSelector(selectTranslations);
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	// TODO: FINISH UP SCREEN LOGIC
	// ask out what message to show up if error

	const handleEndAddBalance = () => {
		dispatch(summarizeBalanceProcess());
		props.handleClose(); // close the add balance modal and clear the state
		navigate(`/${pagesEnum.REQUEST}`, { state: { isOpenRequests: true } });
	};

	return (
		<FormsStack>
			<MessageCard>
				<CenteredText>
					<SuccessIconMessage />
					<HeaderPage1
						title={t(`${balanceTransStepsPrefix}.4.request_received.header.title`)}
						text={t(`${balanceTransStepsPrefix}.4.request_received.header.text`)}
					/>
				</CenteredText>
			</MessageCard>
			<FormButton>
				<Button className="singleFormButton" variant="contained" onClick={handleEndAddBalance}>
					{t(`${balanceTransStepsPrefix}.4.done_button.text`)}
				</Button>
			</FormButton>
		</FormsStack>
	);
}
